import { render, staticRenderFns } from "./TextAlignment.vue?vue&type=template&id=73e4590a&scoped=true"
import script from "./TextAlignment.vue?vue&type=script&lang=js"
export * from "./TextAlignment.vue?vue&type=script&lang=js"
import style0 from "./TextAlignment.vue?vue&type=style&index=0&id=73e4590a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4590a",
  null
  
)

export default component.exports